import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import classNames from 'classnames';
import { injectIntl, defineMessages } from 'react-intl';

import './styles.css';
import ImportantCollegeLinks from '../ImportantCollegeLinks';

const messages = defineMessages({
  transferOverview: {
    id: 'hubs.transfer.overview.title',
    defaultMessage: 'Overview',
  },
  importantLinks: {
    id: 'hubs.transfer.overview.important-links.title',
    defaultMessage: `Important Links`,
  },
});

function TransferOverview({ intl, transferAdmissions }) {
  const infoUrl = get(transferAdmissions, 'infoUrl.value');
  const overview = get(transferAdmissions, 'overview.value');
  const supportUrl = get(transferAdmissions, 'supportUrl.value');
  const creditInfoUrl = get(transferAdmissions, 'creditInfoUrl.value');
  const financialAidUrl = get(transferAdmissions, 'financialAidUrl.value');

  return (
    (overview || infoUrl || supportUrl || creditInfoUrl || financialAidUrl) && (
      <div
        data-cy="transfer-overview"
        className="transfer-common-container transfer-overview common-core-width"
      >
        <p className="section-title">{intl.formatMessage(messages.transferOverview)}</p>
        <div>
          {overview && <p className="section-text">{overview}</p>}
          <div
            className={classNames({
              'overview-links': true,
              'padding-left-5': !!overview,
            })}
          >
            {(infoUrl || supportUrl || creditInfoUrl || financialAidUrl) && (
              <React.Fragment>
                <p className="overview-links-title">
                  {intl.formatMessage(messages.importantLinks)}
                </p>
                <ImportantCollegeLinks
                  infoUrl={infoUrl}
                  supportUrl={supportUrl}
                  creditInfoUrl={creditInfoUrl}
                  financialAidUrl={financialAidUrl}
                />
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    )
  );
}

TransferOverview.propTypes = {
  intl: PropTypes.object,
  transferAdmissions: PropTypes.object,
};

export default injectIntl(TransferOverview);
